/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as selectorsNsir from '../../../store/nsir/reducer';
import * as selectorsNsmp from '../../../store/nsmp/reducer';
import { isUsoMutuo, isInspecaoFibraOptica, isInspecaoMtBt, isInspecaoAuditoriaFaixa, isTrue } from 'utils';
import MtBtNsmpModal from './mtbt/MtBtNsmpModal';
import { isAnexoNsmp, TIPO_NSMP_EVIDENCIA_CAMPO } from './utils/nsmpRowTypes';
import UsoMutuoModal from './nsmp-view/UsoMutuoModal';
import DefaultModal from './nsmp-view/DefaultModal';
import UsoMutuoNewModal from './nsmp-view/UsoMutuoNewModal';
import UsoMutuoEntregaSucataModal from './nsmp-view/UsoMutuoEntregaSucataModal';
import UsoMutuoPesagemSucataModal from './nsmp-view/UsoMutuoPesagemSucataModal';
import UsoMutuoEvidenciaCampoModal from './nsmp-view/UsoMutuoEvidenciaCampoModal';
import FibraOpticaModal from './nsmp-view/FibraOpticaModal';
import NsmpAnexoModal from './nsmp-view/NsmpAnexoModal';
import AuditoriaFaixaModal from './nsmp-view/AuditoriaFaixaModal';

const sharedModalProps = (props) => ({
  open: props.open,
  onCancel: props.onCancel,
  onConfirm: props.onConfirm,
  selectedId: props.selectedId,
  readOnly: props.readOnly,
  nsirTitle: props.nsirTitle,
  onNext: props.onNext,
  onPrevious: props.onPrevious,
  hasNext: props.hasNext,
  hasPrevious: props.hasPrevious,
  carouselPosition: props.carouselPosition,
});

const resolveNsmpRow = (selectedId, nsmpSelected, nsmps) => {
  if (!selectedId) return null;
  if (nsmpSelected && nsmpSelected.id === selectedId) return nsmpSelected;
  return (nsmps || []).find((row) => row.id === selectedId) || null;
};

const NsmpModal = (props) => {
  const {
    onConfirmAndNext,
    nsirData,
    nsmpSelected,
    nsmps,
    selectedId,
    createTipoNsmp,
  } = props;

  const nsmpRow = resolveNsmpRow(selectedId, nsmpSelected, nsmps);
  const isAnexo = nsmpRow && isAnexoNsmp(nsmpRow);
  const resolvedTipoNsmp = nsmpRow?.tipoNsmp || createTipoNsmp;

  if (isAnexo) {
    return <NsmpAnexoModal {...sharedModalProps(props)} />;
  }

  if (isUsoMutuo(nsirData.tipoServicoId) && !!nsirData.newFlow) {
    if (resolvedTipoNsmp === 'ENTREGA_SUCATA') {
      return <UsoMutuoEntregaSucataModal {...sharedModalProps(props)} />;
    }
    if (resolvedTipoNsmp === 'PESAGEM_SUCATA') {
      return <UsoMutuoPesagemSucataModal {...sharedModalProps(props)} />;
    }
    if (resolvedTipoNsmp === TIPO_NSMP_EVIDENCIA_CAMPO) {
      return <UsoMutuoEvidenciaCampoModal {...sharedModalProps(props)} />;
    }
    return <UsoMutuoNewModal
      {...sharedModalProps(props)}
      digitadorId={nsirData.digitadorId}
      inspetorId={nsirData.inspetorId}
    />;
  }

  if (isUsoMutuo(nsirData.tipoServicoId)) {
    return <UsoMutuoModal
      {...sharedModalProps(props)}
      onConfirmAndNext={onConfirmAndNext}
      digitadorId={nsirData.digitadorId}
    />;
  }

  if (isInspecaoFibraOptica(nsirData.tipoServicoId) && !!nsirData.newFlow) {
    return <FibraOpticaModal
      {...sharedModalProps(props)}
      onConfirmAndNext={onConfirmAndNext}
      digitadorId={nsirData.digitadorId}
    />;
  }

  if (isInspecaoMtBt(nsirData.tipoServicoId)) {
    return <MtBtNsmpModal
      {...sharedModalProps(props)}
      onConfirmAndNext={onConfirmAndNext}
    />;
  }

  if (isInspecaoAuditoriaFaixa(nsirData.tipoServicoId) && isTrue(nsirData.newFlow)) {
    return <AuditoriaFaixaModal
      {...sharedModalProps(props)}
      onConfirmAndNext={onConfirmAndNext}
    />;
  }

  return <DefaultModal
    {...sharedModalProps(props)}
    onConfirmAndNext={onConfirmAndNext}
  />;
};

NsmpModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onConfirmAndNext: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selectedId: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  nsirData: PropTypes.object.isRequired,
  nsmpSelected: PropTypes.object,
  nsmps: PropTypes.array,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  carouselPosition: PropTypes.object,
  createTipoNsmp: PropTypes.string,
};

NsmpModal.defaultProps = {
  selectedId: undefined,
  nsmpSelected: {},
  nsmps: [],
  createTipoNsmp: null,
};

const mapStateToProps = state => ({
  nsirData: selectorsNsir.getNsirSelected(state),
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
  nsmps: selectorsNsmp.getNsmps(state),
});

export default connect(mapStateToProps, null)(NsmpModal);
